export const complianceNAList = [
  { label: 'Pass', value: 'Pass' },
  { label: 'Minor Non-Conformance', value: 'Minor Non-Conformance' },
  { label: 'Major Non-Conformance', value: 'Major Non-Conformance' },
  { label: 'N/A', value: 'N/A' },
];

export const passFailList = [
  { label: 'Pass', value: 'Pass' },
  { label: 'Fail', value: 'Fail' },
];

export const allergenLevelList = [
  { label: 'Contains', value: 'Contains' },
  { label: 'May Contain', value: 'May Contain' },
  { label: 'Free From', value: 'Free From' },
  { label: 'N/A', value: 'N/A' },
];

export const presentOrNotPresentList = [
  { label: 'Present', value: 'Present' },
  { label: 'Not Present', value: 'Not Present' },
];

export const presentOrNotPresentListOrNA = [
  { label: 'Present', value: 'Present' },
  { label: 'Not Present', value: 'Not Present' },
  { label: 'N/A', value: 'N/A' },
];

export const analyticalTestsList = [
  { label: 'Ash', value: 'Ash' },
  { label: 'Bostwick', value: 'Bostwick' },
  { label: 'Breakage', value: 'Breakage' },
  { label: 'Brix', value: 'Brix' },
  { label: 'Brookfield (RV/DV)', value: 'Brookfield (RV/DV)' },
  {
    label: 'Certifications vs Ingredients',
    value: 'Certifications vs Ingredients',
  },
  { label: 'Consistency', value: 'Consistency' },
  { label: 'CO2', value: 'CO2' },
  { label: 'Defects', value: 'Defects' },
  { label: 'Density', value: 'Density' },
  { label: 'Dimensions', value: 'Dimensions' },
  { label: 'Drain Weight (g)', value: 'Drain Weight (g)' },
  { label: 'Fat', value: 'Fat' },
  { label: 'Fiber', value: 'Fiber' },
  { label: 'Gross weight (g)', value: 'Gross weight (g)' },
  { label: 'H2O KF', value: 'H2O KF' },
  { label: 'Inclusions (Components)', value: 'Inclusions (Components)' },
  { label: 'Moisture', value: 'Moisture' },
  { label: 'Net Contents', value: 'Net Contents' },
  { label: 'pH', value: 'pH' },
  { label: 'Piece Count', value: 'Piece Count' },
  { label: 'Piece Depth', value: 'Piece Depth' },
  { label: 'Piece Diameter', value: 'Piece Diameter' },
  { label: 'Piece Height', value: 'Piece Height' },
  { label: 'Piece Length', value: 'Piece Length' },
  { label: 'Piece Thickness', value: 'Piece Thickness' },
  { label: 'Piece Weight', value: 'Piece Weight' },
  { label: 'Piece Width', value: 'Piece Width' },
  { label: 'Protein', value: 'Protein' },
  { label: 'Ro-Tap', value: 'Ro-Tap' },
  { label: 'Salt', value: 'Salt' },
  { label: 'Solids', value: 'Solids' },
  { label: 'TA', value: 'TA' },
  { label: 'Visual', value: 'Visual' },
  { label: 'N/A', value: 'N/A' },
];

export const countryOfOriginList = [
  { label: 'Not Present', value: 'Not Present' },
  { label: 'ABW', value: 'ABW' },
  { label: 'AFG', value: 'AFG' },
  { label: 'AGO', value: 'AGO' },
  { label: 'AIA', value: 'AIA' },
  { label: 'ALA', value: 'ALA' },
  { label: 'ALB', value: 'ALB' },
  { label: 'AND', value: 'AND' },
  { label: 'ARE', value: 'ARE' },
  { label: 'ARG', value: 'ARG' },
  { label: 'ARM', value: 'ARM' },
  { label: 'ASM', value: 'ASM' },
  { label: 'ATA', value: 'ATA' },
  { label: 'ATF', value: 'ATF' },
  { label: 'ATG', value: 'ATG' },
  { label: 'AUS', value: 'AUS' },
  { label: 'AUT', value: 'AUT' },
  { label: 'AZE', value: 'AZE' },
  { label: 'BDI', value: 'BDI' },
  { label: 'BEL', value: 'BEL' },
  { label: 'BEN', value: 'BEN' },
  { label: 'BES', value: 'BES' },
  { label: 'BFA', value: 'BFA' },
  { label: 'BGD', value: 'BGD' },
  { label: 'BGR', value: 'BGR' },
  { label: 'BHR', value: 'BHR' },
  { label: 'BHS', value: 'BHS' },
  { label: 'BIH', value: 'BIH' },
  { label: 'BLM', value: 'BLM' },
  { label: 'BLR', value: 'BLR' },
  { label: 'BLZ', value: 'BLZ' },
  { label: 'BMU', value: 'BMU' },
  { label: 'BOL', value: 'BOL' },
  { label: 'BRA', value: 'BRA' },
  { label: 'BRB', value: 'BRB' },
  { label: 'BRN', value: 'BRN' },
  { label: 'BTN', value: 'BTN' },
  { label: 'BVT', value: 'BVT' },
  { label: 'BWA', value: 'BWA' },
  { label: 'CAF', value: 'CAF' },
  { label: 'CAN', value: 'CAN' },
  { label: 'CCK', value: 'CCK' },
  { label: 'CHE', value: 'CHE' },
  { label: 'CHL', value: 'CHL' },
  { label: 'CHN', value: 'CHN' },
  { label: 'CIV', value: 'CIV' },
  { label: 'CMR', value: 'CMR' },
  { label: 'COD', value: 'COD' },
  { label: 'COG', value: 'COG' },
  { label: 'COK', value: 'COK' },
  { label: 'COL', value: 'COL' },
  { label: 'COM', value: 'COM' },
  { label: 'CPV', value: 'CPV' },
  { label: 'CRI', value: 'CRI' },
  { label: 'CUB', value: 'CUB' },
  { label: 'CUW', value: 'CUW' },
  { label: 'CXR', value: 'CXR' },
  { label: 'CYM', value: 'CYM' },
  { label: 'CYP', value: 'CYP' },
  { label: 'CZE', value: 'CZE' },
  { label: 'DEU', value: 'DEU' },
  { label: 'DJI', value: 'DJI' },
  { label: 'DMA', value: 'DMA' },
  { label: 'DNK', value: 'DNK' },
  { label: 'DOM', value: 'DOM' },
  { label: 'DZA', value: 'DZA' },
  { label: 'ECU', value: 'ECU' },
  { label: 'EGY', value: 'EGY' },
  { label: 'ERI', value: 'ERI' },
  { label: 'ESH', value: 'ESH' },
  { label: 'ESP', value: 'ESP' },
  { label: 'EST', value: 'EST' },
  { label: 'ETH', value: 'ETH' },
  { label: 'FIN', value: 'FIN' },
  { label: 'FJI', value: 'FJI' },
  { label: 'FLK', value: 'FLK' },
  { label: 'FRA', value: 'FRA' },
  { label: 'FRO', value: 'FRO' },
  { label: 'FSM', value: 'FSM' },
  { label: 'GAB', value: 'GAB' },
  { label: 'GBR', value: 'GBR' },
  { label: 'GEO', value: 'GEO' },
  { label: 'GGY', value: 'GGY' },
  { label: 'GHA', value: 'GHA' },
  { label: 'GIB', value: 'GIB' },
  { label: 'GIN', value: 'GIN' },
  { label: 'GLP', value: 'GLP' },
  { label: 'GMB', value: 'GMB' },
  { label: 'GNB', value: 'GNB' },
  { label: 'GNQ', value: 'GNQ' },
  { label: 'GRC', value: 'GRC' },
  { label: 'GRD', value: 'GRD' },
  { label: 'GRL', value: 'GRL' },
  { label: 'GTM', value: 'GTM' },
  { label: 'GUF', value: 'GUF' },
  { label: 'GUM', value: 'GUM' },
  { label: 'GUY', value: 'GUY' },
  { label: 'HKG', value: 'HKG' },
  { label: 'HMD', value: 'HMD' },
  { label: 'HND', value: 'HND' },
  { label: 'HRV', value: 'HRV' },
  { label: 'HTI', value: 'HTI' },
  { label: 'HUN', value: 'HUN' },
  { label: 'IDN', value: 'IDN' },
  { label: 'IMN', value: 'IMN' },
  { label: 'IND', value: 'IND' },
  { label: 'IOT', value: 'IOT' },
  { label: 'IRL', value: 'IRL' },
  { label: 'IRN', value: 'IRN' },
  { label: 'IRQ', value: 'IRQ' },
  { label: 'ISL', value: 'ISL' },
  { label: 'ISR', value: 'ISR' },
  { label: 'ITA', value: 'ITA' },
  { label: 'JAM', value: 'JAM' },
  { label: 'JEY', value: 'JEY' },
  { label: 'JOR', value: 'JOR' },
  { label: 'JPN', value: 'JPN' },
  { label: 'KAZ', value: 'KAZ' },
  { label: 'KEN', value: 'KEN' },
  { label: 'KGZ', value: 'KGZ' },
  { label: 'KHM', value: 'KHM' },
  { label: 'KIR', value: 'KIR' },
  { label: 'KNA', value: 'KNA' },
  { label: 'KOR', value: 'KOR' },
  { label: 'KWT', value: 'KWT' },
  { label: 'LAO', value: 'LAO' },
  { label: 'LBN', value: 'LBN' },
  { label: 'LBR', value: 'LBR' },
  { label: 'LBY', value: 'LBY' },
  { label: 'LCA', value: 'LCA' },
  { label: 'LIE', value: 'LIE' },
  { label: 'LKA', value: 'LKA' },
  { label: 'LSO', value: 'LSO' },
  { label: 'LTU', value: 'LTU' },
  { label: 'LUX', value: 'LUX' },
  { label: 'LVA', value: 'LVA' },
  { label: 'MAC', value: 'MAC' },
  { label: 'MAF', value: 'MAF' },
  { label: 'MAR', value: 'MAR' },
  { label: 'MCO', value: 'MCO' },
  { label: 'MDA', value: 'MDA' },
  { label: 'MDG', value: 'MDG' },
  { label: 'MDV', value: 'MDV' },
  { label: 'MEX', value: 'MEX' },
  { label: 'MHL', value: 'MHL' },
  { label: 'MKD', value: 'MKD' },
  { label: 'MLI', value: 'MLI' },
  { label: 'MLT', value: 'MLT' },
  { label: 'MMR', value: 'MMR' },
  { label: 'MNE', value: 'MNE' },
  { label: 'MNG', value: 'MNG' },
  { label: 'MNP', value: 'MNP' },
  { label: 'MOZ', value: 'MOZ' },
  { label: 'MRT', value: 'MRT' },
  { label: 'MSR', value: 'MSR' },
  { label: 'MTQ', value: 'MTQ' },
  { label: 'MUS', value: 'MUS' },
  { label: 'MWI', value: 'MWI' },
  { label: 'MYS', value: 'MYS' },
  { label: 'MYT', value: 'MYT' },
  { label: 'NAM', value: 'NAM' },
  { label: 'NCL', value: 'NCL' },
  { label: 'NER', value: 'NER' },
  { label: 'NFK', value: 'NFK' },
  { label: 'NGA', value: 'NGA' },
  { label: 'NIC', value: 'NIC' },
  { label: 'NIU', value: 'NIU' },
  { label: 'NLD', value: 'NLD' },
  { label: 'NOR', value: 'NOR' },
  { label: 'NPL', value: 'NPL' },
  { label: 'NRU', value: 'NRU' },
  { label: 'NZL', value: 'NZL' },
  { label: 'OMN', value: 'OMN' },
  { label: 'PAK', value: 'PAK' },
  { label: 'PAN', value: 'PAN' },
  { label: 'PCN', value: 'PCN' },
  { label: 'PER', value: 'PER' },
  { label: 'PHL', value: 'PHL' },
  { label: 'PLW', value: 'PLW' },
  { label: 'PNG', value: 'PNG' },
  { label: 'POL', value: 'POL' },
  { label: 'PRI', value: 'PRI' },
  { label: 'PRK', value: 'PRK' },
  { label: 'PRT', value: 'PRT' },
  { label: 'PRY', value: 'PRY' },
  { label: 'PSE', value: 'PSE' },
  { label: 'PYF', value: 'PYF' },
  { label: 'QAT', value: 'QAT' },
  { label: 'REU', value: 'REU' },
  { label: 'ROU', value: 'ROU' },
  { label: 'RUS', value: 'RUS' },
  { label: 'RWA', value: 'RWA' },
  { label: 'SAU', value: 'SAU' },
  { label: 'SDN', value: 'SDN' },
  { label: 'SEN', value: 'SEN' },
  { label: 'SGP', value: 'SGP' },
  { label: 'SGS', value: 'SGS' },
  { label: 'SHN', value: 'SHN' },
  { label: 'SJM', value: 'SJM' },
  { label: 'SLB', value: 'SLB' },
  { label: 'SLE', value: 'SLE' },
  { label: 'SLV', value: 'SLV' },
  { label: 'SMR', value: 'SMR' },
  { label: 'SOM', value: 'SOM' },
  { label: 'SPM', value: 'SPM' },
  { label: 'SRB', value: 'SRB' },
  { label: 'SSD', value: 'SSD' },
  { label: 'STP', value: 'STP' },
  { label: 'SUR', value: 'SUR' },
  { label: 'SVK', value: 'SVK' },
  { label: 'SVN', value: 'SVN' },
  { label: 'SWE', value: 'SWE' },
  { label: 'SWZ', value: 'SWZ' },
  { label: 'SXM', value: 'SXM' },
  { label: 'SYC', value: 'SYC' },
  { label: 'SYR', value: 'SYR' },
  { label: 'TCA', value: 'TCA' },
  { label: 'TCD', value: 'TCD' },
  { label: 'TGO', value: 'TGO' },
  { label: 'THA', value: 'THA' },
  { label: 'TJK', value: 'TJK' },
  { label: 'TKL', value: 'TKL' },
  { label: 'TKM', value: 'TKM' },
  { label: 'TLS', value: 'TLS' },
  { label: 'TON', value: 'TON' },
  { label: 'TTO', value: 'TTO' },
  { label: 'TUN', value: 'TUN' },
  { label: 'TUR', value: 'TUR' },
  { label: 'TUV', value: 'TUV' },
  { label: 'TWN', value: 'TWN' },
  { label: 'TZA', value: 'TZA' },
  { label: 'UGA', value: 'UGA' },
  { label: 'UKR', value: 'UKR' },
  { label: 'UMI', value: 'UMI' },
  { label: 'URY', value: 'URY' },
  { label: 'USA', value: 'USA' },
  { label: 'UZB', value: 'UZB' },
  { label: 'VAT', value: 'VAT' },
  { label: 'VCT', value: 'VCT' },
  { label: 'VEN', value: 'VEN' },
  { label: 'VGB', value: 'VGB' },
  { label: 'VIR', value: 'VIR' },
  { label: 'VNM', value: 'VNM' },
  { label: 'VUT', value: 'VUT' },
  { label: 'WLF', value: 'WLF' },
  { label: 'WSM', value: 'WSM' },
  { label: 'YEM', value: 'YEM' },
  { label: 'ZAF', value: 'ZAF' },
  { label: 'ZMB', value: 'ZMB' },
  { label: 'ZWE', value: 'ZWE' },
];

export const overallResultList = [
  { label: 'Pass', value: 'Pass' },
  {
    label: 'Pass-Minor Non-Conformance(s)',
    value: 'Pass-Minor Non-Conformance(s)',
  },
  {
    label: 'Fail-Major Non-Conformance(s)',
    value: 'Fail-Major Non-Conformance(s)',
  },
];

export const evaluationTypeList = [
  { label: 'Retail Audit', value: 'Retail Audit' },
  { label: 'Product Approvals', value: 'Product Approvals' },
  { label: 'First Production', value: 'First Production' },
  { label: 'Retests & Complaints', value: 'Retests & Complaints' },
];

export const claimList = [
  { label: 'Not Claimed', value: 'Not Claimed' },
  { label: 'Claimed, Not Certified', value: 'Claimed, Not Certified' },
  { label: 'Claimed, Certified', value: 'Claimed, Certified' },
];

export const gmoList = [
  { label: 'GMO', value: 'GMO' },
  { label: 'Non-GMO', value: 'Non-GMO' },
  { label: 'Not Claimed', value: 'Not Claimed' },
];

export const bioengineeredList = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
  { label: 'No Selection', value: 'No Selection' },
];

export const bioengineeredNAList = [
  { value: 'Bioengineered', label: 'Bioengineered' },
  { value: 'Not Bioengineered', label: 'Not Bioengineered' },
  { value: 'Not Claimed', label: 'Not Claimed' },
  { value: 'N/A', label: 'N/A' },
];

export const bioengineeringClaimsList = [
  { label: 'Claims Bioengineered', value: 'Claims Bioengineered' },
  { label: 'Claims Not Bioengineered', value: 'Claims Not Bioengineered' },
  { label: 'Not Claimed', value: 'Not Claimed' },
];

export const pfasClaimsList = [
  {
    label: 'Claims Intentionally Contains PFAS',
    value: 'Claims Intentionally Contains PFAS',
  },
  {
    label: 'Claims Does Not Intentionally Contain PFAS',
    value: 'Claims Does Not Intentionally Contain PFAS',
  },
  { label: 'Not Claimed', value: 'Not Claimed' },
];

export const rivirAlignmentList = [
  { label: 'Present, Aligns with Specification', value: 'Present, Aligns with Specification' },
  {
    label: 'Present, Does Not Align with Specification',
    value: 'Present, Does Not Align with Specification',
  },
  { label: 'Not Present', value: 'Not Present' },
];

export const nfpAlignmentList = [
  { label: 'Present, Aligns with NFP', value: 'Present, Aligns with NFP' },
  {
    label: 'Present, Does Not Align with NFP',
    value: 'Present, Does Not Align with NFP',
  },
  { label: 'Not Present', value: 'Not Present' },
];

export const kosherNoteList = [
  {
    label: 'Kosher certificate missing in Specification',
    value: 'Kosher certificate missing in Specification',
  },
  {
    label: 'Kosher certificate expired in Specification',
    value: 'Kosher certificate expired in Specification',
  },
];

export const rivirGmoNoteList = [
  {
    label: 'Specification states GMO, label does not',
    value: 'Specification states GMO, label does not',
  },
  {
    label: 'Specification states NGMO, label does not',
    value: 'Specification states NGMO, label does not',
  },
];

export const bioengineeredNoteList = [
  {
    label: 'No bioengineered ingredients claim present in Specification',
    value: 'No bioengineered ingredients claim present in Specification',
  },
  {
    label:
      'Bioengineered ingredients claim in Specification does not align with product label',
    value:
      'Bioengineered ingredients claim in Specification does not align with product label',
  },
  {
    label:
      'Specification states product does not contain bioengineered ingredients but lists ingredients in bioengineered ingredients statement',
    value:
      'Specification states product does not contain bioengineered ingredients but lists ingredients in bioengineered ingredients statement',
  },
  {
    label:
      'Product label or Specification declares product is organic or NGMO but Specification states product contains bioengineered ingredients',
    value:
      'Product label or Specification declares product is organic or NGMO but Specification states product contains bioengineered ingredients',
  },
];

export const pfasNoteList = [
  {
    label:
      "No selection made for 'Does this Product Intentionally Contain PFAS?' dropdown in Specification",
    value:
      "No selection made for 'Does this Product Intentionally Contain PFAS?' dropdown in Specification",
  },
  {
    label:
      "No selection made for 'Does this Product's Packaging Intentionally Contain PFAS?' dropdown in Specification",
    value:
      "No selection made for 'Does this Product's Packaging Intentionally Contain PFAS?' dropdown in Specification",
  },
  {
    label:
      "No selection made for either the 'Does this Product Intentionally Contain PFAS?' or 'Does this Product's Packaging Intentionally Contain PFAS?' dropdowns in Specification",
    value:
      "No selection made for either the 'Does this Product Intentionally Contain PFAS?' or 'Does this Product's Packaging Intentionally Contain PFAS?' dropdowns in Specification",
  },
  {
    label: 'PFAS statement conflicts with PFAS dropdown selections in Specification',
    value: 'PFAS statement conflicts with PFAS dropdown selections in Specification',
  },
];

export const gfClaimNoteList = [
  {
    label: 'Specification states GF, label does not',
    value: 'Specification states GF, label does not',
  },
];

export const dateCodeNomenclatureList = [
  {
    label: 'Date code nomenclature not compliant with AWG standard',
    value: 'Date code nomenclature not compliant with AWG standard',
  },
];

export const issueCategoryList = [
  { label: 'Allergen Discrepancy', value: 'Allergen Discrepancy' },
  { label: 'Analytical Non-Conformance', value: 'Analytical Non-Conformance' },
  {
    label: 'Bio-Engineering Declaration',
    value: 'Bio-Engineering Declaration',
  },
  { label: 'Country of Origin', value: 'Country of Origin' },
  { label: 'Date/Lot Code on Package', value: 'Date/Lot Code on Package' },
  { label: 'Facts Up Front', value: 'Facts Up Front' },
  { label: 'Kosher Certification', value: 'Kosher Certification' },
  {
    label: 'Label-Landing Page Mismatch',
    value: 'Label-Landing Page Mismatch',
  },
  { label: 'Label Specification  Mismatch', value: 'Label Specification  Mismatch' },
  { label: 'Microbial Non-Conformance', value: 'Microbial Non-Conformance' },
  { label: 'NBE', value: 'NBE' },
  { label: 'NBE Discrepancy', value: 'NBE Discrepancy' },
  { label: 'NFP in Specification', value: 'NFP in Specification' },
  { label: 'NFP Landing Pages', value: 'NFP Landing Pages' },
  { label: 'Organic Certification', value: 'Organic Certification' },
  { label: 'Organoleptic Issue', value: 'Organoleptic Issue' },
  { label: 'OTC in Specification', value: 'OTC in Specification' },
  { label: 'Other', value: 'Other' },
  { label: 'Packaging Issue', value: 'Packaging Issue' },
  { label: 'PFAS Issue', value: 'PFAS Issue' },
  { label: 'Photograph Discrepancy', value: 'Photograph Discrepancy' },
  { label: 'QR Code Issue', value: 'QR Code Issue' },
  {
    label: 'Specification-Landing Page Mismatch',
    value: 'Specification-Landing Page Mismatch',
  },
  { label: 'Specification Deficiency', value: 'Specification Deficiency' },
  { label: 'Specification Discrepancy', value: 'Specification Discrepancy' },
];

export const correctiveActionsList = [
  {
    label: 'Align Label and Specification',
    value: 'Align Label and Specification',
  },
  {
    label: 'Align Online Landing Page and Specification',
    value: 'Align Online Landing Page and Specification',
  },
  {
    label: 'Provide Data in Specification field.',
    value: 'Provide Data in Specification field.',
  },
  {
    label: 'Update Label',
    value: 'Update Label',
  },
  {
    label: 'Update Specification',
    value: 'Update Specification',
  },
  {
    label: 'Update Online Landing Page',
    value: 'Update Online Landing Page',
  },
  {
    label: 'Upload Current Documentation to Specification',
    value: 'Upload Current Documentation to Specification',
  },
  {
    label:
      'Please investigate your retained samples, batch records and quality data to determine if any non-conformances were noted and respond with the findings from your investigation.',
    value:
      'Please investigate your retained samples, batch records and quality data to determine if any non-conformances were noted and respond with the findings from your investigation.',
  },
  {
    label: 'Review Quality Assurance Parameters',
    value: 'Review Quality Assurance Parameters',
  },
];

export const complianceCorrectionList = [
  { label: 'Minor NC', value: 'Minor Non-Conformance', title: 'Minor Non-Conformance' },
  { label: 'Major NC', value: 'Major Non-Conformance', title: 'Major Non-Conformance' },
];

export const responsibilityList = [
  { label: 'Daymon', value: 'Daymon' },
  { label: 'Supplier', value: 'Supplier' },
];

export const allergenList = [
  { label: 'Eggs', value: 'Eggs' },
  { label: 'Soy', value: 'Soy' },
  { label: 'Wheat', value: 'Wheat' },
  { label: 'Milk', value: 'Milk' },
  { label: 'Fish', value: 'Fish' },
  { label: 'Sesame', value: 'Sesame' },
  { label: 'Peanuts', value: 'Peanuts' },
  { label: 'Tree Nuts', value: 'Tree Nuts' },
  { label: 'Shellfish', value: 'Shellfish' },
  { label: 'Latex', value: 'Latex' },
];
